import { Dialog, DialogContent } from '@material-ui/core';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
import { ConfirmationDialog, NetworkIndicator } from 'design-system';
import { ConnectedProps, connect } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
// actions
import {
  cleanCopyQuotation,
  copyQuotationInformation,
} from 'src/store/quotation/actions';
import { REQUEST_QUOTATION_COPY } from 'src/store/quotation/requestIdentifiers';

export const CopyQuotationModal = ({
  openModal,
  cleanCopyQuotationAction,
  copyQuotationInformationAction,
}: PropsFromRedux): JSX.Element => {
  const cloningQuotationStatus = useNetworkObserver(REQUEST_QUOTATION_COPY);
  return (
    <>
      <ConfirmationDialog
        data-testid="confirmation-copy-dialog"
        open={openModal}
        message="Al editar la cotización se creará un duplicado de esta misma cotización."
        confirmAction={copyQuotationInformationAction}
        rejectAction={cleanCopyQuotationAction}
        confirmText="De acuerdo"
        rejectText="Cancelar"
      />
      <Dialog
        data-testid="loading-copy-dialogue"
        open={cloningQuotationStatus === 'requesting'}
      >
        <DialogContent>
          <NetworkIndicator
            requesting
            message="Copiando datos de cotización..."
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  openModal: boolean;
} => ({
  openModal: state.quotation.copyQuotationData.openModal,
});

const reduxActions = {
  cleanCopyQuotationAction: cleanCopyQuotation,
  copyQuotationInformationAction: copyQuotationInformation,
};
const connector = connect(mapStateToProps, reduxActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(CopyQuotationModal);
